for (const tab of document.querySelectorAll('.tab-item')) {
    tab.addEventListener('click', function () {
        for (const otherTab of document.querySelectorAll('.tab-item')) {
            otherTab.querySelector('label')?.classList.remove('bg-theme-primary-800');
        }

        this.querySelector('label')?.classList.toggle('bg-theme-primary-800');
    });
}

document.querySelector('.tab-item').click();
